//TODO: GROW-2166 when Productizing if fixed win update the InverseHeader in core component and fix imports
'use client';

import { RadialGradientBG } from '@jouzen/ecom-components';

import InverseHeader from '@/app/components/Experiments/FixedHeader/InverseHeader/InverseHeader';

import MembershipAccolades from './_components/MembershipAccolades/MembershipAccolades';
import MembershipBenefits from './_components/MembershipBenefits/MembershipBenefits';
import MembershipBetterSleep from './_components/MembershipBetterSleep/MembershipBetterSleep';
import MembershipFAQ from './_components/MembershipFAQ/MembershipFAQ';
import MembershipFeatures from './_components/MembershipFeatures/MembershipFeatures';
import MembershipHero from './_components/MembershipHero/MembershipHero';
import MembershipInfoFeatureGrid from './_components/MembershipInfoFeatureGrid/MembershipInfoFeatureGrid';
import MembershipYourHealth from './_components/MembershipYourHealth/MembershipYourHealth';
import { accoladesSlides } from './_data/membershipAccolades';
import { membershipGradients } from './_data/membershipGradients';

const Content = (): JSX.Element => {
  return (
    <RadialGradientBG gradients={membershipGradients}>
      <div data-cy="membership-page">
        <MembershipHero />
        <MembershipFeatures />
        <MembershipInfoFeatureGrid />
        <MembershipAccolades accoladeSlideData={accoladesSlides} />
        <MembershipYourHealth />
        <MembershipBenefits />
        <InverseHeader enter>
          <MembershipFAQ />
          <MembershipBetterSleep />
        </InverseHeader>
      </div>
    </RadialGradientBG>
  );
};

export default Content;
